/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'linkDataSource.accessInstructions': 'アクセス権をリクエストするには、サイト管理者にお問い合わせください。',
  'linkDataSource.accessRequired': 'このコンテンツへのアクセス権がありません',
  'linkDataSource.accessRequiredWithSite': '次のサイトへのアクセス権がありません。',
  'linkDataSource.assets.configModal.aqlSearchInput.helpTooltipText': '構文ヘルプ',
  'linkDataSource.assets.configModal.aqlSearchInput.placeholder': 'AQL で検索',
  'linkDataSource.assets.configModal.objectSchemaSelect.label': 'スキーマを選択',
  'linkDataSource.assets.configModal.objectSchemaSelect.placeholder': 'スキーマを選択',
  'linkDataSource.assets.configModal.objectSchemaSelect.schemaRequired': 'スキーマは必須です',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.learnMoreLink': 'AQL 検索の詳細をご確認ください。',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchDescription': '語句を入力するか、AQL を使って検索できます。',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchTitle': 'オブジェクトを検索する',
  'linkDataSource.assets.configmodal.insertIssuesButtonText': '{objectsCount, plural, other {オブジェクトを挿入}}',
  'linkDataSource.assets.configmodal.insertObjectsTitle': 'オブジェクトの挿入元',
  'linkDataSource.assets.configmodal.updateObjectsButtonText': 'テーブルを更新',
  'linkDataSource.basic-filter.assignee.label': '担当者',
  'linkDataSource.basic-filter.dropdown.select.assignee.unassigned': '未割り当て',
  'linkDataSource.basic-filter.dropdown.select.placeholder': '検索',
  'linkDataSource.basic-filter.error-message': '問題が発生しました',
  'linkDataSource.basic-filter.footer.pagination-details': '{totalCount} 件中 {currentDisplayCount} 件',
  'linkDataSource.basic-filter.loading-message': '読み込み中…',
  'linkDataSource.basic-filter.no-options-message': '一致するものが見つかりませんでした',
  'linkDataSource.basic-filter.project.label': 'プロジェクト',
  'linkDataSource.basic-filter.showMoreButton': '表示を増やす',
  'linkDataSource.basic-filter.status.label': 'ステータス',
  'linkDataSource.basic-filter.type.label': 'タイプ',
  'linkDataSource.checkConnection': '接続を確認して更新するか、後でもう一度お試しください。',
  'linkDataSource.clol-basic-filter.editedOrCreatedBy.label': '編集者または作成者',
  'linkDataSource.column-picker.no-all-items-shown-message.line-1': '検索に一致する結果が多すぎます。',
  'linkDataSource.column-picker.no-all-items-shown-message.line-2': 'キーワードをより具体的にしてもう一度お試しください。',
  'linkDataSource.column-picker.search': 'フィールドを検索',
  'linkDataSource.column-picker.tooltip': '列を設定',
  'linkDataSource.configmodal.basicTextSearchPlaceholder': 'キーワードで課題を検索',
  'linkDataSource.configmodal.basicTextSearchPlaceholder-issue-term-refresh': 'キーワードで作業項目を検索',
  'linkDataSource.configmodal.cancelButtonText': 'キャンセル',
  'linkDataSource.confluence-search.configmodal.cancelButtonText': 'キャンセル',
  'linkDataSource.confluence-search.configmodal.date.range.after.label': '{date} より後',
  'linkDataSource.confluence-search.configmodal.date.range.any.time': '指定なし',
  'linkDataSource.confluence-search.configmodal.date.range.before.label': '{date} より前',
  'linkDataSource.confluence-search.configmodal.date.range.custom': 'カスタム',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.end': '開始日は終了日より前の日付にしてください',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.today': '開始日に将来の日付を指定することはできません',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.to.after.today': '終了日に将来の日付を指定することはできません',
  'linkDataSource.confluence-search.configmodal.date.range.error': '日付範囲エラー',
  'linkDataSource.confluence-search.configmodal.date.range.from': '開始日',
  'linkDataSource.confluence-search.configmodal.date.range.input.placeholder': '日付を選択',
  'linkDataSource.confluence-search.configmodal.date.range.last.month': '過去 30 日',
  'linkDataSource.confluence-search.configmodal.date.range.last.week': '過去 7 日',
  'linkDataSource.confluence-search.configmodal.date.range.last.year': '過去 1 年',
  'linkDataSource.confluence-search.configmodal.date.range.title': '最終更新日',
  'linkDataSource.confluence-search.configmodal.date.range.to': '終了日',
  'linkDataSource.confluence-search.configmodal.date.range.to.Label': 'から',
  'linkDataSource.confluence-search.configmodal.date.range.today': '今日',
  'linkDataSource.confluence-search.configmodal.date.range.update.button': '更新',
  'linkDataSource.confluence-search.configmodal.date.range.yesterday': '昨日',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitle': 'Confluence リストを挿入する',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitleManySites': '次のサイトから Confluence リストを挿入する:',
  'linkDataSource.confluence-search.configmodal.insertResultsButtonText': '結果を挿入',
  'linkDataSource.confluence-search.configmodal.placeholder.issues': '### 件の結果',
  'linkDataSource.confluence-search.configmodal.searchLabel': 'キーワードを入力してページや添付ファイルなどを検索',
  'linkDataSource.confluence-search.no.confluence.sites.access.description': 'アクセスをリクエストするには、管理者にお問い合わせください。',
  'linkDataSource.confluence-search.no.confluence.sites.access.title': 'Confluence サイトへのアクセス権がありません',
  'linkDataSource.datasource.table.authConnectButtonText': '接続',
  'linkDataSource.datasource.table.authScreenDescriptionText': '{providerName} アカウントを接続すると、アトラシアン製品全体でコラボレーションできます。',
  'linkDataSource.datasource.table.authScreenHeaderText': 'ご使用の {providerName} アカウントを接続',
  'linkDataSource.datasource.table.learnMoreAboutSmartLinks': 'スマート リンクの詳細',
  'linkDataSource.issue-line-table.error-403-description': 'このアイテムを編集するには適切な権限が必要です。',
  'linkDataSource.issue-line-table.error-403-title': '変更は保存されません',
  'linkDataSource.issue-line-table.error-generic-description': '更新を完了しようとして問題が発生しました。しばらくしてからもう一度お試しください。この問題が引き続き発生する場合は、サポートに連絡してください。',
  'linkDataSource.issue-line-table.error-generic-title': '問題が発生しました',
  'linkDataSource.issue-line-table.fetch-action-error-generic-description': 'しばらくしてからもう一度お試しください。この問題が引き続き発生する場合は、プロジェクト設定を確認するか、サポートに連絡してください。',
  'linkDataSource.issue-line-table.fetch-action-error-generic-title': 'オプションの取得中に問題が発生しました',
  'linkDataSource.issue-line-table.unwrap-text': 'テキストの折り返しを解除',
  'linkDataSource.issue-line-table.wrap-text': 'テキストを折り返す',
  'linkDataSource.checkConnectionWithSource': '接続を確認して更新するか、<a>Jira でこのクエリを開いて</a>ご確認ください。',
  'linkDataSource.jira-issues.configmodal.basicModeSwitchDisabledTooltipText': 'このクエリを基本モードに切り替えることはできません。',
  'linkDataSource.jira-issues.configmodal.basicModeText': '基本',
  'linkDataSource.jira-issues.configmodal.basicTextSearchPlaceholder-issue-term-refresh': 'キーワードで作業項目を検索',
  'linkDataSource.site-selector.configmodal.chooseSite': 'サイトを選択',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText': '課題を挿入',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText-issue-term-refresh': '作業項目を挿入',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle': 'Jira 課題を挿入する',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle-issue-term-refresh': 'Jira 作業項目を挿入する',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites': '次のサイトから Jira 課題を挿入する',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites-issue-term-refresh': '次のサイトから Jira 作業項目を挿入する',
  'linkDataSource.jira-issues.configmodal.placeholder.issues-issue-term-refresh': '### 件の作業項目',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkDescription': '検索結果の件数をインライン スマート リンクとして表示します',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkLabel': 'インライン リンク',
  'linkDataSource.jira-issues.configmodal.viewModeListDescription': '検索結果をリストとして表示します',
  'linkDataSource.jira-issues.configmodal.viewModeListLabel': 'リスト',
  'linkDataSource.jira-issues.learnMoreLink': 'JQL による検索の詳細',
  'linkDataSource.no.jira.sites.access.description': 'アクセスをリクエストするには、管理者にお問い合わせください。',
  'linkDataSource.no.jira.sites.access.title': 'Jira サイトへのアクセス権がありません',
  'linkDataSource.noResultsFound': '結果が見つかりません',
  'linkDataSource.refresh': '更新',
  'linkDataSource.jira-issues.searchDescription-basic': '挿入する課題をキーワードで検索します。',
  'linkDataSource.jira-issues.searchDescription-jql': 'JQL (Jira クエリ言語) を使用して課題を検索します。',
  'linkDataSource.jira-issues.searchJiraTitle': 'Jira の課題を検索',
  'linkDataSource.unableToLoadItems': 'アイテムを読み込めません',
  'linkDataSource.unableToLoadResults': '結果を読み込めません',
  'linkDataSource.modal-initial-state.beta': 'ベータ版',
  'linkDataSource.modal-initial-state.confluenceSearchTitle': 'Confluence ページを検索',
  'linkDataSource.modal-initial-state.jiraSearchTitle': 'Jira の課題を検索',
  'linkDataSource.modal-initial-state.searchDescription-basic-issue-term-refresh': '挿入する作業項目をキーワードで検索します。',
  'linkDataSource.modal-initial-state.searchDescription-confluence': '挿入するページをキーワードで検索します。',
  'linkDataSource.modal-initial-state.searchDescription-jql-issue-term-refresh': 'JQL (Jira クエリ言語) を使用して作業項目を検索します。',
  'linkDataSource.modal-initial-state.searchTitle-issue-term-refresh': 'Jira 作業項目を検索',
  'linkDataSource.render-type.boolean.false': 'いいえ',
  'linkDataSource.render-type.boolean.true': 'はい',
  'linkDataSource.render-type.user.default.display.name': '未割り当て',
  'linkDataSource.search.configmodal.issueCountText': '{searchCount, plural, other {{searchCount,number} 件の課題}}',
  'linkDataSource.search.configmodal.issueCountText-issue-term-refresh': '{searchCount, plural, other {{searchCount,number} 件の作業項目}}',
  'linkDataSource.search.configmodal.itemCountText': '{searchCount, plural, other {{searchCount,number} 件のアイテム}}',
  'linkDataSource.search.configmodal.resultCountText': '{searchCount, plural, other {{searchCount,number} 件の結果}}',
  'linkDataSource.table-footer.date_formatter.under_one_minute': 'たった今、同期しました',
  'linkDataSource.table-footer.date_formatter.under_over_minute': '{date} に同期しました',
  'linkDataSource.table-footer.item': '{itemCount, plural, other {アイテム}}',
  'linkDataSource.table-footer.loading': '読み込み中...',
  'linkDataSource.table-footer.power-by-jsm': '使用ソリューション: Jira Service Management のアセット',
  'linkDataSource.table-footer.powered-by-assets': 'アセットを使用',
  'linkDataSource.table-footer.refresh': '更新'
};